import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = ({ allowedRoles }) => {

    const userData = JSON.parse(sessionStorage.getItem('userData'));

    if (!userData) {

        return <Navigate to="/login" replace />;
    }

    if (!allowedRoles.includes(userData.userRole.toLowerCase())) {

        return <Navigate to="/not-found" replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;